export const HudHide = (hidden: boolean) => {
    let event = new CustomEvent('hud-hide', {
        detail: {
            hidden: hidden,
        },
    });
    window.dispatchEvent(event);
}